<div id="productInternetSelectorModal">
  <div class="rs-modal-heading">
    <h2 class="rs-modal-heading-title rs-has-subtit" id="selectModalTitle1">
      {{ 'internet.productSelector.title' | translate }}
    </h2>
  </div>
  <div class="rs-modal-content">
    <fieldset class="rs-form-sbox">
      <legend class="show-for-sr">{{ 'internet.productSelector.title' | translate }}</legend>
      <div class="rs-flex-row">
        <div
          *ngFor="let product of productsAvailableForDeepLink; let i = index"
          class="small-12 medium-4 rs-flex-columns"
        >
          <div class="rs-sbox rs-sbox-with-extracontent" (click)="updateSelectedRadio(product)">
            <input id="radio{{ i }}" type="radio" name="radioSbox" />
            <label for="radio{{ i }}">
              <span class="rs-sbox-maincontent">
                <span class="rs-sbox-check-header">
                  <span class="rs-sbox-check"></span>
                  <span class="rs-sbox-check-content">
                    <span class="rs-sbox-title">{{ product.productDescription }}</span>
                    <span x-ms-format-detection="none">{{ product.description }} </span>
                    <span class="rs-txt-s1">{{ product.accessNumber }}</span>
                    <mprd-address
                      [address]="installationAddresses[product.addressKey]"
                      [showInOneLine]="false"
                    ></mprd-address>
                  </span>
                </span>
              </span>
            </label>
          </div>
        </div>
      </div>
    </fieldset>
  </div>
  <div class="rs-modal-footer">
    <div
      class="rs-flex-row rs-flex-middle-medium rs-justify-right-medium rs-flex-dir-col-small-only"
    >
      <div class="rs-flex-columns rs-flex-shrink rs-order-m2">
        <button (click)="onConfirm()" class="rs-btn rs-btn-nl-so close-reveal-modal">
          {{ 'internet.productSelector.confirm' | translate }}
        </button>
      </div>
      <div class="rs-flex-columns rs-order-m1">
        <button (click)="onCancel()" class="rs-btn rs-btn-second rs-btn-nl-m close-reveal-modal">
          {{ 'internet.productSelector.cancel' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
